export default __webpack_public_path__ + "static/media/logo-fm-print.61dc66ea.svg";